








import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";
import AppBar from "@/components/app-bar.vue";
import ResultsNavigationDrawer from "@/components/results/results-navigation-drawer.vue";

@Component({
  components: {
    "app-bar": AppBar,
    "results-navigation-drawer": ResultsNavigationDrawer
  }
})
export default class ResultsLayout extends Vue {
  get game() {
    return vxm.games.db[vxm.results.gameId];
  }

  get teams() {
    return vxm.results.teams;
  }
}
